<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 36 36"
    class="d-flex align-center justify-center"
  >
    <circle
      cx="18"
      cy="18"
      r="15.5"
      stroke-width="5"
      :stroke="backgroundColor"
      fill="none"
    />
    <circle
      cx="18"
      cy="18"
      r="15.5"
      stroke-width="5"
      :stroke="color"
      :stroke-linecap="strokeLinecap"
      stroke-dasharray="0 85.2157007286 12.1736715327"
      stroke-dashoffset="0"
      fill="none"
      transform-origin="center"
    >
      <animate
        attributeName="stroke-dasharray"
        attributeType="XML"
        dur="2400ms"
        repeatCount="indefinite"
        values="0 73.042029196 24.3473430653; 0 24.3473430653 73.042029196; 0 73.042029196 24.3473430653;"
        keyTimes="0; 0.75; 1"
        keySplines="0.5 0 0.5 1; 0.5 0 0.5 1"
        calcMode="spline"
      />
      <animateTransform
        attributeName="transform"
        attributeType="XML"
        type="rotate"
        dur="1200ms"
        repeatCount="indefinite"
        by="360"
      />
    </circle>
  </svg>
</template>

<script setup lang="ts">
import type { StylesheetSizeProp } from '@/types'

const {
  size = '52px',
  color = '#008CFF',
  backgroundColor = '#EBEEF5',
  strokeLinecap = 'round',
} = defineProps<{
  size?: StylesheetSizeProp
  color?: string
  backgroundColor?: string
  strokeLinecap?: 'round' | 'square' | 'butt'
}>()
</script>
